import {GuestAnswer} from "../types/types";

export const EmptyGuestAnswer :GuestAnswer = {
    firstName: '', lastName: '',
    attendance: undefined,
    mealPreference: '',
    stayToSleepFriday: false,
    stayToSleepSaturday: false,
    brunchAttendance: false,
}